import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import { FleetSetting, FleetSettingFormValues } from "./types";
import { transformFleetSetting } from "./transformation";

/*---------------------------------------------------------------------------------------
  FLEET SETTINGS - GET
-----------------------------------------------------------------------------------------*/
export const getFleetSettingsAPI = async (): Promise<FleetSetting> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/fleet",
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformFleetSetting(response.data);
};

/*---------------------------------------------------------------------------------------
  FLEET SETTINGS - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateFleetSettingsAPI = async (
  formValues: FleetSettingFormValues,
  t: (key: string) => string
): Promise<FleetSetting> => {
  const response = await createApiCall(
    {
      path: "/v1/settings/fleet",
      method: "PUT",
      body: {
        vehicleCategoryIds: formValues.vehicleCategoryIds,
        vehicleStepKeys: formValues.vehicleStepKeys,
      },
    },
    {
      getMessage: {
        success: () => t("admin.settings.fleet.message.update"),
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformFleetSetting(response.data);
};
